export default "__VITE_ASSET__268dfbd4__"